module.exports = __webpack_public_path__ + "assets/img/4.15ff9571.jpg";